module.exports = __webpack_public_path__ + "img/brand-08.cddf7ae6.png";